import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

// 기준치 초과 강조해야 할 때 기준 참고
// 대형주 +-0.25%, 중소형주 +-0.5%, 섹터 +-1%

const ChangeValue = observer(
    ({
        value,
        suffix,
        sign = false,
        className,
        round,
    }: {
        value: number;
        sign?: boolean;
        suffix?: string;
        className?: string;
        round?: number;
    }) => {
        const displayValue = useMemo(() => {
            let displayValue = String(value);
            if (_.isNumber(round)) {
                displayValue = value.toFixed(round);
            }
            return displayValue;
        }, [value, round]);

        return (
            <span
                className={twMerge(
                    value > 0 && 'text-up',
                    value === 0 && 'text-base-content/60',
                    value < 0 && 'text-down',
                    className,
                )}
            >
                {sign && value > 0 && '+'}
                {displayValue}
                {suffix}
            </span>
        );
    },
);

export default ChangeValue;
